import { render, staticRenderFns } from "./BaseFileUploader2.vue?vue&type=template&id=5936a99e&scoped=true&"
import script from "./BaseFileUploader2.vue?vue&type=script&lang=js&"
export * from "./BaseFileUploader2.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileUploader2.vue?vue&type=style&index=0&id=5936a99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5936a99e",
  null
  
)

export default component.exports